// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_RiiH2","shareLine":"shareLine_flF9T","content1":"content1_MEGuN","content2":"content2_ChnWU","content3":"content3_ZHJgz","button":"button_Lr2iO"};